var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShow)?_c('td',{class:_vm.widthClasses},[_c('span',[_vm._v(_vm._s(_vm.item.title))]),(_vm.item.subtitle)?_c('span',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.item.subtitle))]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }